/**
 * Size Chart Popup Functionality
 */

const initSizeChartPopup = () => {
  const triggerButtons = document.querySelectorAll(
    ".size-chart-trigger-button"
  );

  if (!triggerButtons.length) {
    return; // No size charts on this page, exit early
  }

  triggerButtons.forEach((button) => {
    // Find the parent size chart wrapper
    const sizeChartWrapper = button.closest(".brandy-size-chart-wrapper");
    if (!sizeChartWrapper) return;

    // Find the size chart container
    const sizeChartContainer = sizeChartWrapper.querySelector(
      ".brandy-size-chart-container.is-popup"
    );
    if (!sizeChartContainer) return;

    // Add click event to trigger button
    button.addEventListener("click", (e) => {
      e.preventDefault();
      showPopup(sizeChartContainer);
    });
  });
};

// Only initialize if DOM is ready, or if already loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSizeChartPopup);
} else {
  // DOM already loaded
  initSizeChartPopup();
}

const showPopup = (container) => {
  if (!container) return;

  // Add is-active class to show popup
  container.classList.add("is-active");

  // Add close button functionality if not already present
  addCloseButton(container);

  // Prevent body scroll when popup is open
  document.body.style.overflow = "hidden";

  // Add escape key functionality (only once per popup instance)
  if (!container.dataset.escapeHandlerAdded) {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape" && container.classList.contains("is-active")) {
        hidePopup(container);
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    container.dataset.escapeHandlerAdded = "true";
    // Store handler for cleanup if needed
    container._escapeHandler = handleEscapeKey;
  }

  // Add backdrop click functionality (only once)
  if (!container.dataset.backdropHandlerAdded) {
    container.addEventListener("click", (e) => {
      if (e.target === container && container.classList.contains("is-active")) {
        hidePopup(container);
      }
    });
    container.dataset.backdropHandlerAdded = "true";
  }
};

const hidePopup = (container) => {
  if (!container) return;

  // Remove is-active class to hide popup
  container.classList.remove("is-active");

  // Restore body scroll
  document.body.style.overflow = "";
};

const addCloseButton = (container) => {
  // Check if close button already exists
  if (container.querySelector(".popup-close-btn")) return;

  const sizeChart = container.querySelector(".brandy-size-chart");
  if (!sizeChart) return;

  // Create close button
  const closeButton = document.createElement("button");
  closeButton.className = "popup-close-btn";
  closeButton.innerHTML = "&times;";
  closeButton.setAttribute("aria-label", "Close");
  closeButton.setAttribute("type", "button");

  // Add click event
  closeButton.addEventListener("click", () => {
    hidePopup(container);
  });

  // Insert close button as first child of size chart
  sizeChart.insertBefore(closeButton, sizeChart.firstChild);
};
